import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=39c5c0d0&scoped=true&"
import script from "./DetailOrder.vue?vue&type=script&lang=js&"
export * from "./DetailOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c5c0d0",
  null
  
)

export default component.exports